export default __webpack_public_path__ + "static/media/RecordButton.801a351e.txt";